import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

import { getPublicAssetUrl } from 'src/utils/helpers'

export const MapPin = (brand: Brand): string => {
  const brandAdjusted = brand === 'cottages.com' ? 'cottages' : brand

  return getPublicAssetUrl(
    `/map-pins/brand-${brandAdjusted}--pin-not-active@2x.png`,
  )
}
